

/******************************************************
    Lazy loader
******************************************************/
import 'lazysizes';
import 'lazysizes/plugins/bgset/ls.bgset';

// polyfills
import 'lazysizes/plugins/respimg/ls.respimg';


export default function initLazyload() {

}